import { Application } from "../../../../Api";
import { ApplicationData, ApplicationDataInterface } from "../../ApplicationData";

export interface CustomApplicationDataInterface extends ApplicationDataInterface {
    areaOfDeployment: string,
    salaryRequest: string,
    period: string,
    becomingAwareThrough: string,
    becomingAwareThroughNotes: string,
    additionalNotes: string,
    entranceDate: Date | null,
    completeApplicationFile: File | undefined,
    letterFile: File | undefined,
    applicantPhotoFile: File | undefined,
    schoolDiplomaFile: File | undefined,
    certificateOfEnrollmentFile: File | undefined,
    compulsoryTraineeshipCertificateFile: File | undefined,
    schoolCertificateFile: File | undefined,
    pid:string,
    it:string
}

export interface CheckboxFieldInterface {
    displayName: string,
    value: boolean,
    onChange: (e: any) => void,
}

export class CheckboxField implements CheckboxFieldInterface {
    displayName;
    value: boolean;
    onChange: (e: any) => void;

    constructor(displayName: string){
        this.displayName = displayName;
        this.value = false;

        this.onChange = (e: any) => {
            this.value = e.target.checked;
        }
    }
}

export class CustomApplicationData extends ApplicationData implements CustomApplicationDataInterface {
    areaOfDeployment: string = "";
    salaryRequest: string = "";
    period: string = "";
    becomingAwareThrough: string = "";
    becomingAwareThroughNotes: string = "";
    additionalNotes: string = "";
    entranceDate: Date | null = null;
    completeApplicationFile: File | undefined = undefined;
    letterFile: File | undefined = undefined;
    applicantPhotoFile: File | undefined = undefined;
    schoolDiplomaFile: File | undefined = undefined;
    certificateOfEnrollmentFile: File | undefined = undefined;
    compulsoryTraineeshipCertificateFile: File | undefined = undefined;
    schoolCertificateFile: File | undefined = undefined;
    firstName: string = "";
    lastName: string = "";
    emailAddress: string = "";
    phoneNumber: string = "";
    cvFile: File | undefined = undefined;
    additionalFiles: File[] | null = null;
    terms: boolean = false;
    // H.o.n.e.y.p.o.t
    name: string = "";
    email: string = "";
    pid:string="";
    it:string="";
    getApplication(tenant: string, jobId: string,jobList:string): Application {
        let application = super.getApplication(tenant, jobId,jobList);
        application.customProperties = [];
        application.customProperties.push(
            { name: "areaOfDeployment", value: this.areaOfDeployment },
            { name: "salaryRequest", value: this.salaryRequest },
            { name: "period", value: this.period },
            { name: "becomingAwareThrough", value: this.becomingAwareThrough },
            { name: "becomingAwareThroughNotes", value: this.becomingAwareThroughNotes },
            { name: "additionalNotes", value: this.additionalNotes },
            { name: "entranceDate", value: this.entranceDate?.toString() ?? "" },
        );

        return application;
    }
}
